/**
 * Título de la ventana modal (ventana de simulación de descarga)
 */
export const modalSimulacionTituloElement = document.getElementById("pedimentoExportacionName");
